import { Dropdown, Space } from "antd";
import React, { Component } from "react";
import ProposalBloc from "../../../bloc/proposal_bloc";
import QuotationBloc from "../../../bloc/quotation_bloc";
import Config from "../../../Config";
import "./app_dropdown_action.css";
import LanguageBloc from "../../../bloc/language_bloc";
import Labels from "../../constant/labels";
import App_notice_dialog from "../../dialog/app_notice_dialog/app_notice_dialog";
import AppDialog from "../app_dialog/app_dialog";
import AuthBloc from "../../../bloc/auth_bloc";
import UtilBloc from "../../../bloc/util_bloc";

export default class ImageAction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mooduleConfig: {},
      isOpenDeleteDialog:false,
      isOpenCancelViewingDialog: false
    };
  }
  componentDidMount() {    
    this.setState({
      moduleConfig: Config,
    });
  }

  stateConfig() {
    return this.state.moduleConfig;
  }

  stateItemId() {
    return this.props.id;
  }

  stateQuotationId() {
    return this.props.id;
  }

  stateQuotationIdByProposal() {
    return this.props.quotationId;
  }

  stateModule() {
    return this.props.module;
  }

  stateEntity() {
    return this.props.entity;
  }

  stateStatus() {
    return this.props.status;
  }

  getAssetsContextPath() {
    return "/myCUEPACSCare";
  }

  stateIsOpenDeleteDialog(){
    return this.state.isOpenDeleteDialog;
  }

  stateIsOpenCancelViewingDialog() {
    return this.state.isOpenCancelViewingDialog;
  }
  

  async onProceed() {
    let quotationId = this.stateQuotationId();
    this.setState({
      loading: true,
    });

    ProposalBloc.createNewProposal(quotationId)
    .then((result) => {
      if (result.success) {
        this.setState({
          loading: false,
        });
        let id = result.data[0].proposal.id;
        window.location.href = `${Config.routes.assetsContext}/${Config.routes.generic.proposal_provide_details}/${id}`;
      } else {
        this.setState({
          loading:false,
          openErrorCreateDialog:true,
          errorCreate:result.message
        })
      } 
    })
    .catch((e) => {
      this.setState({
        loading: false,
      });
    });

  }

  async onDelete(){
    let id = this.stateItemId();    
    this.setState({
      loading: true,
    });
    let payload={
      "clientId":this.props.clientId
    } 
        
    if(this.stateModule()=="quotation"){
      QuotationBloc.deleteQuotationById(id,payload).then((result)=>{
        if(result.success){
          this.setState({
            loading: false,
            isOpenDeleteDialog:false
          }); 
          if(this.props.refresh){
            this.props.refresh();
          }
        }      
      }).catch(e=>{        
        this.setState({
          openErrorCreateDialog:true,
          loading: false,
          isOpenDeleteDialog:false,
          errorCreate:e?.response.data.message
        })
      })
    } else {
      ProposalBloc.deleteProposalById(id).then((result)=>{
        if(result.success){
          this.setState({
            loading: false,
            isOpenDeleteDialog:false
          }); 
          if(this.props.refresh){
            this.props.refresh();
          }
        }      
      }).catch(e=>{
        console.log("Api Error");
      })     
    }
  }

  getLabelsDeleteDialog(){
    if(this.stateModule()=="quotation"){
      return [
        "LBL_QUOTATION_DELETE_DIALOG_TITLE",
        "LBL_QUOTATION_DELETE_DIALOG_DESC",
        "LBL_QUOTATION_DELETE_YES"
      ];
    } else {
      return [
        "LBL_PROPOSAL_DELETE_DIALOG_TITLE",
        "LBL_PROPOSAL_DELETE_DIALOG_DESC",
        "LBL_PROPOSAL_DELETE_YES"
      ];
    }
  }

  openDeleteDialog(){
    this.setState({
      isOpenDeleteDialog:true
    })
  }

  openCancelViewingDialog(){
    this.setState({
      isOpenCancelViewingDialog:true
    })
  }

  onCloseCancelViewingDialog(e){
    
    if(e=="yes"){
      this.setState({
        isOpenCancelViewingDialog:false,
        loading:true
      })
      this.releaseProposal();
    } else {
      this.setState({
        isOpenCancelViewingDialog:false
      })
    }    
  }

  async releaseProposal() {    
    let payload = {
        "proposalId": this.stateItemId()
    }
    ProposalBloc.cancelProposalById(payload).then((result) => {
        if (result.success) {
            this.setState({
                loading: false,
            });
            window.location.href = `/${Config.context}/${Config.routes.generic.proposal_pending}`;
        }
    }).catch(e => {
        this.setState({
            loading: false,
        })
    })
}

  onCloseDeleteDialog(){
    this.setState({
      isOpenDeleteDialog:false
    })
  }

  onActionButtonDialog(e){    
    if(e=="yes"){
      this.onDelete();
    } else {
      this.onCloseDeleteDialog();
    }
  }

  async viewProposal(path){    
    let id = this.stateItemId();    
    this.setState({
      loading: true,
    });
    let payload={
      "proposalId":id
    } 
        
    if(this.stateEntity()=="checker_approval_list" && this.props.action=="pending" ){
       ProposalBloc.viewProposalById(payload).then((result)=>{
        if(result.success){
          this.setState({
            loading: false,           
          }); 
          window.location.href=path+"/"+"processing";          
        }      
      }).catch(e=>{        
        this.setState({        
          loading: false,         
        })
      })
    } else {
      window.location.href=path+"/"+this.props.action;
    }
  }

  releaseProposalSupervisor(){    
    let supervisorName=false;
    let supervisorActionDate=false;
    
    if(!UtilBloc.isNullOrEmpty(this.props.supervisorName)){
      supervisorName=true
    }
    if(!UtilBloc.isNullOrEmpty(this.props.supervisorActionDate)){
      supervisorActionDate=true
    }
    return supervisorName && supervisorActionDate && (this.props.status=="PENDING_DC_SP")
  }

  releaseProposalCac(){
    let cacName=false;
    let cacActionDate=false;
    if(!UtilBloc.isNullOrEmpty(this.props.cacName)){
      cacName=true
    }
    if(!UtilBloc.isNullOrEmpty(this.props.cacActionDate)){
      cacActionDate=true
    }
    return cacName && cacActionDate && (this.props.status=="PENDING_DC_CAC")    
  }

  render() {
    return (
      <>
        <App_notice_dialog
            isOpen={this.stateIsOpenDeleteDialog()}
            title={LanguageBloc.getTextByCode(Labels[this.getLabelsDeleteDialog()[0]])}
            subTitle={
              LanguageBloc.getTextByCode(Labels[this.getLabelsDeleteDialog()[1]])
            }            
            negativeButton={LanguageBloc.getTextByCode(Labels.LBL_DELETE_NO)}
            positiveButton={LanguageBloc.getTextByCode(this.getLabelsDeleteDialog()[2])}
            onCloseDialog={(e) => {
              this.onActionButtonDialog(e);
            }}
        />
        <App_notice_dialog
          showClose={true}
          isOpen={this.stateIsOpenCancelViewingDialog()}
          title={"Do you confirm to release this proposal?"}
          subTitle={``}
          positiveButton={"Yes, Release Proposal"}
          negativeButton={"No, Do Not Release Proposal"}
          onCloseDialog={(e) => {
            this.onCloseCancelViewingDialog(e)
            // window.location.href = this.stateBackStep();
          }}
        />
        <AppDialog
            isOpen={this.state.openErrorCreateDialog}
            title={LanguageBloc.getTextByCode(Labels.LBL_ERROR)}
            description={this.state.errorCreate}
            buttonLabel={null}
            onClick={(e) => {
              this.setState({
                openErrorCreateDialog:false
              })
            }}
         />
        {
          this.props.role=='supervisor' && 
          <img 
            className="ml-2"
            onClick={()=>{
              if(this.releaseProposalSupervisor()==true){
                this.openCancelViewingDialog();
              }              
            }}
            src={
              this.getAssetsContextPath() + `/assets/icons/${this.releaseProposalSupervisor()==true ? "ActiveRelease" :"InactiveRelease" }.svg`
            }
            alt="View More"
          />
        }

        {
          this.props.role=='cac' && 
          <img
            className="ml-2" 
            onClick={()=>{
              if(this.releaseProposalCac()==true){
                this.openCancelViewingDialog();
              }              
            }}
            src={
              this.getAssetsContextPath() + `/assets/icons/${this.releaseProposalCac()==true ? "ActiveRelease" :"InactiveRelease" }.svg`
            }
            alt="View More"
          />
        }
        
      </>
    );
  }
}
